module.exports = __webpack_public_path__ + "img/milho.051cf943.svg";